@if (control) {
  <div>
    <div nz-row [nzGutter]="8">
      <div nz-col nzXs="24" nzSm="24" nzMd="24" [nzLg]="options.split ? 12 : 24">
        <strong>{{ control.mk ? (control.mk | actrans) : control.label }}</strong>
           @if ( control.data.canEditHtml  ) { <!--control.data.editHtml &&-->
            <nz-form-item>
              <nz-form-control >
                <label nz-checkbox [(ngModel)]="control.data.editHtmlEnabled" [ngModelOptions]="{standalone: true}" (ngModelChange)="onHtmlChange($event)">
                  {{ 'common.form.editHtml' | actrans }}</label>
              </nz-form-control>
            </nz-form-item>
          }

        <nz-tabs nzSize="small" (nzSelectedIndexChange)="onTabChange($event)">
          @for (child of control.children; track child) {
            <nz-tab [nzTitle]="((child.data.langName | actrans | str))">
              <bt-dynamic-form-control [control]="child" [form]="fg()" (change)="onChange($event)" ></bt-dynamic-form-control>
            </nz-tab>
          }
        </nz-tabs>
        <!-- @if (bas.envtest) {
        <div>
          <pre>
            options: {{ options | json }}
            gtelg: {{ bas.ui.r.gtelg }}
          </pre>
        </div>
        } -->
      </div>
      @if (options.split && bas.ui.r.gtelg) {
        <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="12">
          <strong>{{ 'common.preview' | actrans }}</strong>
          <nz-tabs nzSize="small">
            <!-- <nz-tab [nzTitle]="(('common.preview' | actrans | str))">
            <div></div>
          </nz-tab> -->
          @for (child of control.children; track child) {
            <nz-tab [nzTitle]="((child.data.langName | actrans | str))">
              <!-- <bt-dynamic-form-control [control]="child" [form]="fg()" (change)="onChange($event)" ></bt-dynamic-form-control> -->
              <div [innerHTML]="fg().get(child.key)?.value | trusthtml"></div>
            </nz-tab>
          }
        </nz-tabs>
      </div>
    }
  </div>
</div>
}

